<header *ngIf="isWithHeader" class="dialog-header" [ngClass]="dialogClass">
  <button mat-icon-button mat-dialog-close="true">
    <i class="material-icons">clear</i>
  </button>
</header>
<mat-dialog-content>
  <ng-template #dialogContent></ng-template>
</mat-dialog-content>
